var map = {
	"./computerscience.json": [
		42,
		42
	],
	"./english.json": [
		927,
		927
	],
	"./gk.json": [
		771,
		771
	],
	"./maths.json": [
		104,
		104
	],
	"./pokemon_quiz.json": [
		542,
		542
	],
	"./science.json": [
		637,
		637
	],
	"./scores.json": [
		762,
		762
	],
	"./sst.json": [
		789,
		789
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 860;
module.exports = webpackAsyncContext;